"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var Tab_1 = __importDefault(require("@material-ui/core/Tab"));
var Tabs_1 = __importDefault(require("@material-ui/core/Tabs"));
var config_1 = require("@pbl/pbl-react-web-components/lib/config/config");
var TicketCardContent_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/ticket-entry/TicketCardContent"));
var TicketSlider_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/ticket-entry/TicketSlider"));
var TicketTabContent_1 = __importDefault(require("@pbl/pbl-react-web-components/lib/ticket-entry/TicketTabContent"));
var React = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var constants_1 = __importDefault(require("../../../config/constants"));
var styles_1 = __importDefault(require("../styles"));
var TicketCardContentV2_1 = __importDefault(require("../v2/TicketCardContentV2"));
var TicketCard = function (_a) {
    var loading = _a.loading, successfulEntered = _a.successfulEntered, showConsentText = _a.showConsentText, showTicketCardView = _a.showTicketCardView, isMobileView = _a.isMobileView, isQuickCardVisible = _a.isQuickCardVisible, ticketNumber = _a.ticketNumber, validationCode = _a.validationCode, tabKey = _a.tabKey, navigateToGames = _a.navigateToGames, showSampleTicketHelpImage = _a.showSampleTicketHelpImage, showSampleTicket = _a.showSampleTicket, theme = _a.theme, onTicketSubmit = _a.onTicketSubmit, isRestricted = _a.isRestricted, hideDBGTab = _a.hideDBGTab, handleContactUs = _a.handleContactUs, _b = _a.v2, v2 = _b === void 0 ? false : _b, activeTabKey = _a.activeTabKey, setActiveTabKey = _a.setActiveTabKey, customerVariant = _a.customerVariant;
    var t = (0, react_i18next_1.useTranslation)().t;
    var classes = (0, styles_1.default)(theme)();
    var initialTabs = config_1.config.internalConfig.TICKET_TABS_DATA;
    var ticketTabs = React.useMemo(function () {
        return hideDBGTab
            ? initialTabs.filter(function (tab) { return tab.tabKey !== 'drawTicket'; })
            : initialTabs;
    }, [hideDBGTab, initialTabs]);
    var _c = React.useState(activeTabKey !== null && activeTabKey !== void 0 ? activeTabKey : config_1.config.internalConfig.TICKET_TABS_DATA[0].tabKey), activeTab = _c[0], setActiveTab = _c[1];
    var titleRefs = React.useRef([]);
    var contentRefs = React.useRef([]);
    React.useEffect(function () {
        if (!!ticketTabs &&
            !!config_1.config.internalConfig.TICKET_TABS_DATA &&
            ticketTabs.length !== config_1.config.internalConfig.TICKET_TABS_DATA.length) {
            setActiveTab(config_1.config.internalConfig.TICKET_TABS_DATA[0].tabKey);
        }
    }, [ticketTabs]);
    React.useEffect(function () {
        if (ticketTabs.length > 0 && activeTab === '') {
            setActiveTab(ticketTabs[0].tabKey);
        }
    }, [activeTab, ticketTabs]);
    var onSubmit = function (ticketBarcodeNumber, validationNumber, currentTabKey) {
        onTicketSubmit(ticketBarcodeNumber, validationNumber, currentTabKey);
    };
    var showSampleTicketImage = function () {
        showSampleTicket(activeTab);
    };
    var showTicketHelpImage = function (currentTabKey) {
        showSampleTicketHelpImage(currentTabKey);
    };
    var handleTabChange = function (_value, tabValue) {
        setActiveTab(tabValue);
        if (setActiveTabKey) {
            setActiveTabKey(tabValue);
        }
    };
    var addTabIndex = function (index) {
        return {
            'tab-index': "".concat(index)
        };
    };
    if (showTicketCardView && !isMobileView) {
        return (React.createElement("div", { className: classes.ticketCardContainer }, ticketTabs === null || ticketTabs === void 0 ? void 0 : ticketTabs.map(function (tab, index) {
            var _a, _b, _c, _d;
            return v2 ? (React.createElement(TicketCardContentV2_1.default, { key: tab.tabKey, ticketTab: tab, loading: loading, onSubmit: onSubmit, showSampleTicketHelpImage: showTicketHelpImage, navigateToGames: (_a = tab.navigateToGames) !== null && _a !== void 0 ? _a : navigateToGames, successfulEntered: successfulEntered, showConsentText: showConsentText, label: t(tab.tabTitle), tabLogo: tab.tabLogo, tabAltText: t((_b = tab.tabAltText) !== null && _b !== void 0 ? _b : tab.tabTitle), tabIndex: index, isRestricted: isRestricted, handleContactUs: handleContactUs, customerVariant: customerVariant, cardIndex: index, contentRefs: contentRefs, titleRefs: titleRefs })) : (React.createElement(TicketCardContent_1.default, { classes: classes, key: tab.tabKey, ticketTab: tab, loading: loading, onSubmit: onSubmit, showSampleTicketHelpImage: showTicketHelpImage, navigateToGames: (_c = tab.navigateToGames) !== null && _c !== void 0 ? _c : navigateToGames, successfulEntered: successfulEntered, showConsentText: showConsentText, label: t(tab.tabTitle), tabLogo: tab.tabLogo, tabAltText: t((_d = tab.tabAltText) !== null && _d !== void 0 ? _d : tab.tabTitle), isQuickCardVisible: isQuickCardVisible, tabIndex: index, theme: theme, isRestricted: isRestricted, handleContactUs: handleContactUs, ticketFieldsData: {
                    ticketBarcodeNumber: ticketNumber,
                    validationNumber: validationCode,
                    tabKey: tabKey
                } }));
        })));
    }
    if (isMobileView) {
        return (React.createElement("div", null,
            React.createElement(TicketSlider_1.default, { data: ticketTabs, loading: loading, showSampleTicketHelpImage: showTicketHelpImage, onTicketSubmit: onTicketSubmit, navigateToGames: navigateToGames, successfulEntered: successfulEntered, showConsentText: showConsentText, isQuickCardVisible: isQuickCardVisible, isRestricted: isRestricted, handleContactUs: handleContactUs })));
    }
    return (React.createElement(Card_1.default, { className: classes.ticketCard },
        React.createElement(Tabs_1.default, { value: activeTab, onChange: handleTabChange, indicatorColor: "primary", textColor: "primary", className: classes.tabs, centered: true }, ticketTabs === null || ticketTabs === void 0 ? void 0 : ticketTabs.map(function (tab, index) { return (React.createElement(Tab_1.default, __assign({ key: tab.tabKey, label: t(tab.tabTitle), "aria-label": "View ".concat(t(tab.tabTitle), " of ticket"), value: tab.tabKey }, addTabIndex(index + 1), { style: { minWidth: ticketTabs.length > 2 ? 140 : 160 } }))); })), ticketTabs === null || ticketTabs === void 0 ? void 0 :
        ticketTabs.map(function (tab) {
            var _a;
            return activeTab === tab.tabKey && (React.createElement(TicketTabContent_1.default, { key: tab.tabKey, ticketTab: tab, loading: loading, onSubmit: onSubmit, showSampleTicket: showSampleTicketImage, navigateToGames: (_a = tab.navigateToGames) !== null && _a !== void 0 ? _a : navigateToGames, successfulEntered: successfulEntered, showConsentText: showConsentText, isRestricted: isRestricted, hideMaterialStickyLabel: constants_1.default.HIDE_MATERIAL_UI_STICKY_LABEL }));
        })));
};
exports.default = TicketCard;
//# sourceMappingURL=TicketCard.js.map